/**
 * @ngdoc object
 * @name modules.core
 * @description
 *
 */
angular.module('festzelt-os.modules.core', [

]);

require('./routes');

require('./components/al-selectize/component');
require('./components/al-color-picker/component');
require('./components/al-loader/component');
require('./components/al-iframe-preview/component');
require('./components/al-qr-code-content-selector/component');
require('./components/al-font-selector/component');
require('./components/al-notification-bell/component');



// WEBPACK FOOTER //
// ./src/app/modules/core/module.js